define([
	"dojo/_base/declare",
	"underscore",
	"csi/config",
	"csi/form/Widget",
	"csi/reflection",
	"csi/store/_base",
	"csi/store/Names",
	"csi/xml"
], function(declare,_,config,Widget,reflection,csiStore,Names,xml) {

	var OPTION_TYPE = "MerchOptionType";

	return declare(Widget, {

		getFieldStore: function(/*Field*/field, /*String*/value) {

			if (field.m_name == OPTION_TYPE) {
				var productSubtypeUrl = this.getFieldValue("Subtype");
				var optionSubtypeUrls = config.getSubtypeSetting(productSubtypeUrl, "ChildrenSubtypes");
				var activeOptionSubtypes = [csiStore.nameObject("")];
				_.each(optionSubtypeUrls, function(url) {
					if (config.getSubtypeSetting(url, "Active"))
						activeOptionSubtypes.push(csiStore.nameObject(reflection.getObject(url)));
				});
				return new Names({
					data: activeOptionSubtypes
				});
			}

			return this.inherited(arguments);

		},

		onChangeSubtype: function(/*View*/defView, /*Field*/field, /*Any*/value) {
			// summary: update options fields based on subtype
			var bType = (xml.isValidURL(value) && config.getSubtypeSetting(value, "ChildrenSubtypes").length > 0);
			this.setFieldRequired("MerchOptionType", bType);
			this.setFieldDisabled("MerchOptionType", !bType);
		},

		_resolveView: function() {
			// summary: initialize name field to MerchCollection name
			this.inherited(arguments);
			this.setFieldDisabled("MerchOptionType", true);

		}
	});
});